import { Brain } from '@tunasong/icons'
import type { FC } from 'react'
import { Tooltip } from '../primitives/tooltip.js'
import styles from './ai-generated-badge.module.css'

export type AIGeneratedBadgeSize = 'xs' | 'sm' | 'md'

export interface AIGeneratedBadgeProps {
  /** Defaults to 'sm'. xs = icon-only, sm = icon + 'AI', md = icon + 'AI-generated'. */
  size?: AIGeneratedBadgeSize
  /** Render with the dark overlay backdrop — for placement over images / audio. */
  overlay?: boolean
  /** Override className for layout positioning (e.g. absolute overlay placement). */
  className?: string
}

const ariaLabel = 'AI-generated by Tunabrain'
const tooltipTitle = 'AI-generated by Tunabrain'

const iconPxBySize: Record<AIGeneratedBadgeSize, number> = {
  xs: 12,
  sm: 16,
  md: 20,
}

const visibleLabelBySize: Record<AIGeneratedBadgeSize, string | null> = {
  xs: null,
  sm: 'AI',
  md: 'AI-generated',
}

export const AIGeneratedBadge: FC<AIGeneratedBadgeProps> = ({ size = 'sm', overlay = false, className }) => {
  const label = visibleLabelBySize[size]
  const badge = (
    <span
      role="img"
      aria-label={ariaLabel}
      data-size={size}
      data-overlay={overlay ? 'true' : undefined}
      className={[styles.badge, className].filter(Boolean).join(' ')}
    >
      <Brain size={iconPxBySize[size]} aria-hidden={true} />
      {label ? <span className={styles.label}>{label}</span> : null}
    </span>
  )
  return <Tooltip title={tooltipTitle}>{badge}</Tooltip>
}

export default AIGeneratedBadge
